import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormDataItem, FormElementItem } from 'src/app/interfaces/form-data';
import { RequestsService } from 'src/app/services/requests.service';

@Component({
  selector: 'app-resource-renewal',
  templateUrl: './resource-renewal.component.html',
})
export class ResourceRenewalComponent implements OnInit {
  @Input() item: any;
  currentActionId: string = '';
  reqForm: FormGroup = this.fb.group({
    type: ['', [Validators.required]],
    author: ['', [Validators.required]],
    service: ['', [Validators.required]],
    title: ['', [Validators.required]],
    notes: [''],
  });

  formData: any;

  customFunctions = {
    refresh: (field: FormDataItem, formData: FormData) => {
      console.log('$refresh()', field, formData);
    },
    action: (element: FormElementItem, formData: FormData) => {
      console.log('$action()', element, formData);
    },
  };

  constructor(
    private readonly modalService: NgbModal,
    private readonly fb: FormBuilder,
    private readonly appService: RequestsService,
    private readonly activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.getFormData(this.item.renewId);
    console.log(this.item);
  }
  getFormData(renewId: string) {
    this.appService.getFormByRenew(renewId).subscribe((data: any) => {
      this.currentActionId = data.currentActionId;
      this.formData = {
        fields: data.form.fields,
        elements: data.form.elements,
      };
    });
  }
  confirmRenew(event: any) {
    if (event.valid) {
      this.activeModal.close({
        currentActionId: this.currentActionId,
        form: this.formData,
        valid: event.valid,
      });
    } else {
      console.log('test');
    }
  }
  onEvent(eventName: any, $event: any) {
    console.log('(' + eventName + ')', $event);
  }
  closeModal() {
    this.modalService.dismissAll();
  }
}
